import CompositeIndexChart from 'components/Charts/CompositeIndexChart';
import { useCompositeEditionIndex, useRefreshCompositeEditionIndex, useRegenerateCompositeEditionIndex } from 'hooks/queries/useCompositeIndex';

export default function CompositeEditionIndexCard() {
  const { data: compositeIndex, isLoading } = useCompositeEditionIndex();
  const refreshMutation = useRefreshCompositeEditionIndex();
  const regenerateMutation = useRegenerateCompositeEditionIndex();

  return (
    <CompositeIndexChart
      compositeIndexData={compositeIndex}
      showTitle
      showFilters
      showMetricCard
      showLastCalculationDate
      useCard
      loading={isLoading}
      onRefreshClick={() => refreshMutation.mutate()}
      onRegenerateClick={() => regenerateMutation.mutate()}
      isRefreshing={refreshMutation.isPending}
      isRegenerating={regenerateMutation.isPending}
    />
  );
}
